const i = {
    controls: '[data-video-controls]',
    playPause: '[data-video-play-pause]',
    rewind: '[data-video-rewind]',
    mute: '[data-video-mute]',
    iconPause: '[data-icon-pause]',
    iconPlay: '[data-icon-play]',
    iconSoundOff: '[data-icon-sound-off]',
    iconSoundOn: '[data-icon-sound-on]',
    slide: '[data-slide]',
    singleMedia: '.main-product__media-single',
  },
  c = 5;
function s(t) {
  const e = t.closest(i.slide) || t.closest(i.singleMedia);
  return e ? e.querySelector('video') : null;
}
function d(t, e) {
  const n = t.querySelector(i.iconPause),
    o = t.querySelector(i.iconPlay);
  n && (n.hidden = e), o && (o.hidden = !e), t.setAttribute('aria-label', e ? 'Play video' : 'Pause video');
}
function u(t, e) {
  const n = t.querySelector(i.iconSoundOff),
    o = t.querySelector(i.iconSoundOn);
  n && (n.hidden = !e), o && (o.hidden = e), t.setAttribute('aria-label', e ? 'Unmute video' : 'Mute video');
}
function r(t) {
  if (t.dataset.videoControlsInitialised === 'true') return;
  const e = s(t);
  if (!e) return;
  t.dataset.videoControlsInitialised = 'true';
  const n = t.querySelector(i.playPause),
    o = t.querySelector(i.rewind),
    a = t.querySelector(i.mute);
  n &&
    (d(n, e.paused),
    n.addEventListener('click', () => {
      e.paused ? e.play() : e.pause();
    }),
    e.addEventListener('play', () => d(n, !1)),
    e.addEventListener('pause', () => d(n, !0))),
    o &&
      o.addEventListener('click', () => {
        e.currentTime = Math.max(0, e.currentTime - c);
      }),
    a &&
      (u(a, e.muted),
      a.addEventListener('click', () => {
        (e.muted = !e.muted), e.muted || (e.removeAttribute('muted'), e.play().catch(() => {})), u(a, e.muted);
      }),
      e.addEventListener('volumechange', () => {
        u(a, e.muted);
      }));
}
function l(t = document) {
  t.querySelectorAll(i.controls).forEach(r);
}
document.addEventListener('DOMContentLoaded', () => l());
export {l as i};
